import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseButtonSizeEnum } from '../base-button/base-button-size.enum';
import { TertiaryButtonComponent } from '../tertiary-button/tertiary-button.component';

@Component({
  selector: 'app-edit-button',
  standalone: true,
  imports: [CommonModule, TertiaryButtonComponent],
  templateUrl: './edit-button.component.html',
  styleUrls: ['./edit-button.component.scss']
})
export class EditButtonComponent implements OnChanges {
  @Input() isExpanded: boolean = false;
  @Input() disabled: boolean = false;
  @Output() clicked = new EventEmitter<void>();

  private _isExpanded = new BehaviorSubject<boolean>(false);
  public isExpanded$ = this._isExpanded as Observable<boolean>;

  public buttonText$ = this.isExpanded$.pipe(
    map(expanded => {
      return expanded ? $localize`Cancel` : $localize`Edit`;
    })
  );

  public iconSrc$ = this.isExpanded$.pipe(
    map(expanded => {
      return expanded ? '' : 'assets/icons/primary/EditIcon.svg';
    })
  );

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isExpanded) this._isExpanded.next(this.isExpanded);
  }

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
